import React, {
  type ComponentProps,
  type ReactNode,
  memo,
  useState,
} from "react";
import { UncontrolledTooltip } from "reactstrap";

export interface ITooltipProps {
  tag?: string;
  isOpen?: boolean;
  children: ReactNode;
  tooltipRender: ReactNode;
  tooltipProps?: Omit<ComponentProps<typeof UncontrolledTooltip>, "target">;
}

export const Tooltip = memo(
  ({
    tag: Tag = "span",
    isOpen,
    children,
    tooltipProps,
    tooltipRender,
  }: ITooltipProps) => {
    const [elementRef, setElementRef] = useState<HTMLElement | null>(null);
    if (!isOpen) {
      return <>{children}</>;
    }
    return (
      // @ts-ignore
      <Tag ref={setElementRef}>
        {children}
        {elementRef && (
          <UncontrolledTooltip
            placement="right"
            target={elementRef}
            {...tooltipProps}
          >
            {tooltipRender}
          </UncontrolledTooltip>
        )}
      </Tag>
    );
  },
);
Tooltip.displayName = "Tooltip";
